import axios from 'axios';
import cleanDeep from 'clean-deep';

const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
};

export const call = async (method, url, config, params) => {
  const promise = new Promise(async (resolve, reject) => {
    let response = null;

    try {
      switch(method) {
        case METHODS.GET:
          response = await axios.get(url, config);
          break;
        case METHODS.POST:
          response = await axios.post(url, params, config);
          break;
        case METHODS.PUT:
          response = await axios.put(url, params, config);
          break;
        case METHODS.DELETE:
          response = await axios.delete(url, {
            ...config,
            data: params
          });
          break;
        default:
          break;
      }

      resolve(response.data.data);
    } catch (error) {
      reject(error);
    }
  });

  return promise;
}

export class APIManager {
  static _instance = null;

  constructor() {
    this.dispatch = null;
    this.actions = {};
  }

  initialize(dispatch) {
    this.dispatch = dispatch;
  }

  /**
   * Refresh tokens for requests
   * @returns (Object) jwt tokens
   */
  getAuthorizedRequestConfig = (tokens) => {
    if (!tokens) {
      return {};
    }

    const axiosConfig = {
      headers: {
        'Authorization': `Bearer ${tokens.accessToken.jwtToken}`,
        'X-Identity': tokens.idToken.jwtToken,
        "Content-Type": "application/json",
      },
      crossdomain: true
    };

    return axiosConfig;
  }

  call = async (method, url, config, params, exceptionHandler) => {
    const promise = new Promise(async (resolve, reject) => {
      let response = null;

      // DDB used to not allow null values, but currently does
      // we need to look out for major errors related to this seemingly minor change below
      // const cleanedParams = cleanDeep(params);
      const cleanedParams = params;
  
      try {
        switch(method) {
          case METHODS.GET:
            response = await axios.get(url, config);
            break;
          case METHODS.POST:
            response = await axios.post(url, cleanedParams, config);
            break;
          case METHODS.PUT:
            response = await axios.put(url, cleanedParams, config);
            break;
          case METHODS.DELETE:
            response = await axios.delete(url, {
              ...config,
              data: cleanedParams
            });
            break;
          default:
            break;
        }

        if (typeof response.data !== 'object' && response.data === "") {
          reject(new Error("Your email or password is wrong. please try again"));
        }
  
        resolve(response.data.data);
      } catch (error) {
        const errorResponse = error.response;

        if (errorResponse) {
          switch (errorResponse.status) {
            case 401:
              if (this.actions['logout']) {
                this.actions['logout']();
              }
              break;
            default:
              reject(error);
              break;
          }
        }
      }
    });
  
    return promise;
  }

  static get Instance() {
    return this._instance || (this._instance = new this());
  }
};
